import { render, staticRenderFns } from "./DCMA.vue?vue&type=template&id=58af387a&"
import script from "./DCMA.vue?vue&type=script&lang=js&"
export * from "./DCMA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports